import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue, useSetAtom } from 'jotai';
import { selectedFacilityAtom } from '@/store/facilityAtom';
import { siteGroupExperienceAtom } from '@/store/siteGroupExperienceAtom';
import { lookupService } from '@/services/lookupService';

/**
 * Resolves the site-group experience (theme tokens, feature flag overrides,
 * practice info) for the currently selected facility and writes it to
 * siteGroupExperienceAtom. No-op when no facility is selected. Cached for
 * 15 min to match the backend's IMemoryCache TTL on GetSiteGroupExperienceAsync.
 */
export function useSiteGroupExperience() {
  const facility = useAtomValue(selectedFacilityAtom);
  const setExperience = useSetAtom(siteGroupExperienceAtom);

  const query = useQuery({
    queryKey: ['siteGroupExperience', facility?.id],
    queryFn: () => lookupService.getSiteGroupExperience(facility!.id),
    enabled: !!facility?.id,
    staleTime: 15 * 60 * 1000,
  });

  useEffect(() => {
    if (query.data) setExperience(query.data);
  }, [query.data, setExperience]);

  return query;
}
